import { createSlice } from "@reduxjs/toolkit";
import {
  deleteWithdrawlRequest,
  generateGiftCodeOTP,
  getGiftCodeDetails,
  getGiftCodeLedger,
  getWalletBalance,
  getWalletTransctionHistory,
  getWalletWithdrawalHistory,
  getWithdrawlRequest,
  insertTempWalletBalance,
  insertWithdrawlRequest,
  redeemGiftCode,
  updateWithdrawlRequest,
  verifyWalletAmount,
} from "./services/wallet.services";

interface IVerifyEmailState {
  loading: boolean;
  error: string;
  walletDetails: any;
  walletIndex: number;
  giftcodeDetails: any;
  withdrawRequestDetails: any;
  walletWithdrawalHostory: any[];
  walletTransctionHostory: any[];
  GiftCodeLedgerDetails: any;
}

const initialState: IVerifyEmailState = {
  loading: false,
  error: "",
  walletDetails: {},
  walletIndex: -1,
  giftcodeDetails: {},
  withdrawRequestDetails: {},
  walletWithdrawalHostory: [],
  walletTransctionHostory: [],
  GiftCodeLedgerDetails: {},
};

const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    setWalletIndex: (state, action) => {
      state.walletIndex = action.payload;
    },
    clearWalletIndex: (state) => {
      state.walletIndex = initialState.walletIndex;
    },
    clearwithdrawRequestDetails: (state) => {
      state.withdrawRequestDetails = initialState.withdrawRequestDetails;
    },
    clearGiftCodeLedgerDetails: (state) => {
      state.GiftCodeLedgerDetails = initialState.GiftCodeLedgerDetails;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getWalletWithdrawalHistory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getWalletWithdrawalHistory.fulfilled, (state, action) => {
      state.loading = false;
      state.walletWithdrawalHostory = action.payload;
    });
    builder.addCase(getWalletWithdrawalHistory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.walletWithdrawalHostory = initialState.walletWithdrawalHostory;
    });
    builder.addCase(getWalletTransctionHistory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getWalletTransctionHistory.fulfilled, (state, action) => {
      state.loading = false;
      state.walletTransctionHostory = action.payload;
    });
    builder.addCase(getWalletTransctionHistory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.walletTransctionHostory = initialState.walletTransctionHostory;
    });
    builder.addCase(getWalletBalance.pending, (state) => {
      state.loading = true;
      // state.walletDetails = {}
      state.error = "";
    });
    builder.addCase(getWalletBalance.fulfilled, (state, action) => {
      state.loading = false;
      state.walletDetails = action.payload?.Data;
    });
    builder.addCase(getWalletBalance.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.walletDetails = initialState.walletDetails;
    });
    builder.addCase(insertTempWalletBalance.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(insertTempWalletBalance.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(insertTempWalletBalance.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(verifyWalletAmount.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(verifyWalletAmount.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(verifyWalletAmount.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(generateGiftCodeOTP.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(generateGiftCodeOTP.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(generateGiftCodeOTP.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(redeemGiftCode.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(redeemGiftCode.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(redeemGiftCode.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(insertWithdrawlRequest.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(insertWithdrawlRequest.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(insertWithdrawlRequest.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateWithdrawlRequest.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateWithdrawlRequest.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(updateWithdrawlRequest.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getGiftCodeDetails.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getGiftCodeDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.giftcodeDetails = action.payload?.Data;
    });
    builder.addCase(getGiftCodeDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.giftcodeDetails = initialState.giftcodeDetails;
    });
    builder.addCase(getWithdrawlRequest.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getWithdrawlRequest.fulfilled, (state, action) => {
      state.loading = false;
      state.withdrawRequestDetails = action.payload?.Data;
    });
    builder.addCase(getWithdrawlRequest.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.withdrawRequestDetails = initialState.withdrawRequestDetails;
    });
    builder.addCase(deleteWithdrawlRequest.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteWithdrawlRequest.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteWithdrawlRequest.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getGiftCodeLedger.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getGiftCodeLedger.fulfilled, (state, action) => {
      state.loading = false;
      state.GiftCodeLedgerDetails = action.payload;
    });
    builder.addCase(getGiftCodeLedger.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.GiftCodeLedgerDetails = initialState.GiftCodeLedgerDetails;
    });
  },
});

export const {
  setWalletIndex,
  clearWalletIndex,
  clearwithdrawRequestDetails,
  clearGiftCodeLedgerDetails,
} = walletSlice.actions;

export default walletSlice.reducer;
